'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dId$0024 from "./app.data.-App-Document-Id$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsReadPage$Node$1(labelProperty$7, id, text) {
  this.aXD = null;
  this.Ym = null;
  this.Yn = null;
  this.aXD = labelProperty$7;
  this.Ym = id;
  this.Yn = text;
}
export { $c_Lapp_pages_DocumentsReadPage$Node$1 as $c_Lapp_pages_DocumentsReadPage$Node$1 };
$p = $c_Lapp_pages_DocumentsReadPage$Node$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentsReadPage$Node$1;
/** @constructor */
function $h_Lapp_pages_DocumentsReadPage$Node$1() {
}
export { $h_Lapp_pages_DocumentsReadPage$Node$1 as $h_Lapp_pages_DocumentsReadPage$Node$1 };
$h_Lapp_pages_DocumentsReadPage$Node$1.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_DocumentsReadPage$Node$1)) {
    var x = this.Ym;
    var x$2 = x$0.Ym;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      return (this.Yn === x$0.Yn);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "Node";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Ym;
  }
  if ((n === 1)) {
    return this.Yn;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "text";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.bXX = (function() {
  var _\uff3fobj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sjs_js_special_package$().mz($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)([])));
  var this$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(this.Ym, $j_app$002edata$002e$002dApp$002dDocument$002dId$0024.$m_Lapp_data_AppDocumentId$().Jp());
  var value$proxy1 = this$5.bq.aT(this$5.bp);
  _\uff3fobj.id = value$proxy1;
  var key = this.aXD;
  var value = this.Yn;
  _\uff3fobj[key] = value;
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sjs_js_special_package$().mz($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T2.r().C)([$j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), "data", _\uff3fobj)])));
});
function $isArrayOf_Lapp_pages_DocumentsReadPage$Node$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kv)));
}
export { $isArrayOf_Lapp_pages_DocumentsReadPage$Node$1 as $isArrayOf_Lapp_pages_DocumentsReadPage$Node$1 };
var $d_Lapp_pages_DocumentsReadPage$Node$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsReadPage$Node$1, "app.pages.DocumentsReadPage$Node$1", ({
  kv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_DocumentsReadPage$Node$1 as $d_Lapp_pages_DocumentsReadPage$Node$1 };
//# sourceMappingURL=app.pages.-Documents-Read-Page$-Node$1.js.map
